/**
 * Settings dialog · Calendars tab — design_handoff_integrations_page frame
 * 20. Same CalendarPickerList as the connect flow, fixed-height (the dialog
 * itself doesn't grow), plus a per-calendar warning when unticking one that
 * was previously synced — its data is actually removed from widgets on
 * save, not just paused, so that needs calling out before it happens.
 */
import React, { useMemo } from "react";
import Icon from "../../../theme/untitled/icons/Icon";
import CalendarPickerList from "../CalendarPickerList";
import styles from "./IntegrationSettingsDialog.module.scss";

const CalendarsTab = ({ integration, selected, onChange, onSelectAll }) => {
  const calendars = integration.settings?.calendars || [];
  const primaryCalendarId = integration.username;

  const newlyUnticked = useMemo(
    () => calendars.filter((c) => c.sync && !selected[c.id]),
    [calendars, selected]
  );
  const warnings = newlyUnticked.map((calendar) => (
    <div key={calendar.id} className={styles.warnStrip}>
      <Icon name="AlertTriangle" size={18} className={styles.warnIcon} />
      <p>
        <b>{calendar.label} will stop syncing when you save</b>
        Its data is removed from your widgets. Tick it again to bring it back
        — nothing is deleted at the source.
      </p>
    </div>
  ));

  return (
    <div>
      <p className={styles.cap}>
        Only ticked calendars sync into Revisual. Everything else on this
        account stays private.
      </p>
      <CalendarPickerList
        calendars={calendars}
        selected={selected}
        onChange={onChange}
        onSelectAll={onSelectAll}
        primaryCalendarId={primaryCalendarId}
        fixedHeight
      />
      {warnings}
    </div>
  );
};

export default CalendarsTab;
